import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f483fbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tpd-course-area" }
const _hoisted_2 = { class: "tp-dashboard-tab mb-25" }
const _hoisted_3 = { class: "tp-dashboard-tab-title" }
const _hoisted_4 = { class: "tp-dashboard-tab-list" }
const _hoisted_5 = ["data-background"]
const _hoisted_6 = { class: "tp-instructor-wrap d-flex justify-content-between" }
const _hoisted_7 = { class: "tp-instructor-info d-flex" }
const _hoisted_8 = { class: "tp-instructor-avatar p-relative profile" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["tooltip"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "19",
    cy: "19",
    r: "18",
    fill: "white",
    stroke: "#E6E8F0"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.352 13.5172L23.272 13.3463C23.056 12.9034 22.808 12.3907 22.656 12.0954C22.288 11.3962 21.656 11.0078 20.88 11H17.112C16.336 11.0078 15.712 11.3962 15.344 12.0954C15.184 12.4062 14.912 12.9656 14.688 13.424L14.64 13.5172C14.616 13.5794 14.552 13.6104 14.488 13.6104C12.56 13.6104 11 15.1332 11 16.9978V21.6127C11 23.4772 12.56 25 14.488 25H23.512C25.432 25 27 23.4772 27 21.6127V16.9978C27 15.1332 25.432 13.6104 23.512 13.6104C23.44 13.6104 23.384 13.5716 23.352 13.5172Z",
    fill: "#303651"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.0035 15.9806C19.8435 15.9806 20.6355 16.2992 21.2275 16.8741C21.8195 17.4568 22.1475 18.2259 22.1475 19.0339C22.1395 19.8808 21.7875 20.6421 21.2195 21.1937C20.6515 21.7454 19.8675 22.0872 19.0035 22.0872C18.1635 22.0872 17.3795 21.7687 16.7795 21.1937C16.1875 20.6111 15.8595 19.8497 15.8595 19.0339C15.8515 18.2259 16.1795 17.4646 16.7715 16.8819C17.3715 16.2992 18.1635 15.9806 19.0035 15.9806ZM19.0035 17.146C18.4835 17.146 17.9955 17.3402 17.6195 17.7054C17.2515 18.0628 17.0515 18.5367 17.0595 19.0262V19.0339C17.0595 19.5389 17.2595 20.0128 17.6275 20.3702C17.9955 20.7276 18.4835 20.9218 19.0035 20.9218C20.0755 20.9218 20.9395 20.075 20.9475 19.0339C20.9475 18.5289 20.7475 18.055 20.3795 17.6976C20.0115 17.3402 19.5235 17.146 19.0035 17.146ZM23.4915 15.7942C23.8915 15.7942 24.2195 16.1127 24.2195 16.5012C24.2195 16.8896 23.8915 17.2004 23.4915 17.2004C23.0915 17.2004 22.7715 16.8896 22.7715 16.5012C22.7715 16.1127 23.0915 15.7942 23.4915 15.7942Z",
    fill: "white"
  })
], -1 /* HOISTED */))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "tp-instructor-course-btn profile" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "18",
    height: "16",
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.624 2.8768L13.539 2.68146C13.3095 2.17536 13.046 1.58935 12.8845 1.25194C12.4935 0.45283 11.822 0.00887902 10.9975 0H6.994C6.1695 0.00887902 5.5065 0.45283 5.1155 1.25194C4.9455 1.6071 4.6565 2.24639 4.4185 2.77026L4.3675 2.8768C4.342 2.94784 4.274 2.98335 4.206 2.98335C2.1575 2.98335 0.5 4.72364 0.5 6.85461V12.1287C0.5 14.2597 2.1575 16 4.206 16H13.794C15.834 16 17.5 14.2597 17.5 12.1287V6.85461C17.5 4.72364 15.834 2.98335 13.794 2.98335C13.7175 2.98335 13.658 2.93896 13.624 2.8768Z",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.00471 5.69173C9.89721 5.69173 10.7387 6.05577 11.3677 6.71282C11.9967 7.37875 12.3452 8.25777 12.3452 9.18119C12.3367 10.149 11.9627 11.0191 11.3592 11.6496C10.7557 12.28 9.92271 12.6706 9.00471 12.6706C8.11221 12.6706 7.27921 12.3066 6.64171 11.6496C6.01271 10.9836 5.66421 10.1135 5.66421 9.18119C5.65571 8.25777 6.00421 7.38763 6.63321 6.7217C7.27071 6.05577 8.11221 5.69173 9.00471 5.69173ZM9.00471 7.02359C8.45221 7.02359 7.93371 7.24556 7.53421 7.66288C7.14321 8.07131 6.93071 8.61293 6.93921 9.17231V9.18119C6.93921 9.75833 7.15171 10.2999 7.54271 10.7084C7.93371 11.1168 8.45221 11.3388 9.00471 11.3388C10.1437 11.3388 11.0617 10.371 11.0702 9.18119C11.0702 8.60405 10.8577 8.06243 10.4667 7.654C10.0757 7.24556 9.55721 7.02359 9.00471 7.02359ZM13.7732 5.47864C14.1982 5.47864 14.5467 5.84268 14.5467 6.28663C14.5467 6.73058 14.1982 7.08574 13.7732 7.08574C13.3482 7.08574 13.0082 6.73058 13.0082 6.28663C13.0082 5.84268 13.3482 5.47864 13.7732 5.47864Z",
      fill: "#333333"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_15 = { class: "tpd-setting-from" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "tpd-input" }
const _hoisted_19 = { for: "first-name" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "tpd-input" }
const _hoisted_22 = { for: "last-name" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "tpd-input" }
const _hoisted_25 = { for: "username" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "tpd-input" }
const _hoisted_28 = { for: "email" }
const _hoisted_29 = { class: "col-lg-6" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "tpd-input" }
const _hoisted_33 = { for: "phone" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "tpd-input" }
const _hoisted_36 = { for: "language" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "en" }, "English", -1 /* HOISTED */))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ar" }, "عربي", -1 /* HOISTED */))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = { class: "col-lg-6" }
const _hoisted_41 = { for: "gender" }
const _hoisted_42 = { class: "mt-3" }
const _hoisted_43 = { class: "form-check form-check-lg form-check-inline" }
const _hoisted_44 = {
  class: "form-check-label",
  for: "gender-male"
}
const _hoisted_45 = { class: "form-check form-check-lg form-check-inline" }
const _hoisted_46 = {
  class: "form-check-label",
  for: "gender-female"
}
const _hoisted_47 = { class: "col-lg-12" }
const _hoisted_48 = { class: "tpd-input" }
const _hoisted_49 = { for: "bio" }
const _hoisted_50 = { class: "tpd-setting-cartificate" }
const _hoisted_51 = { class: "tpd-setting-cartificate-btn text-right" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  key: 0,
  class: "spinner-border spinner-border-sm mr-5",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "tpd-setting-from mt-4" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-lg-6 mb-2" }
const _hoisted_57 = {
  class: "form-label",
  for: "linkedin"
}
const _hoisted_58 = { class: "col-lg-6 mb-2" }
const _hoisted_59 = {
  for: "multiSelect",
  class: "form-label"
}
const _hoisted_60 = { class: "dropdown" }
const _hoisted_61 = {
  class: "btn btn-outline-secondary text-left dropdown-toggle w-100 text-truncate",
  type: "button",
  id: "skillsDropdownMenuButton",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_62 = {
  class: "dropdown-menu",
  "aria-labelledby": "skillsDropdownMenuButton"
}
const _hoisted_63 = { class: "form-check" }
const _hoisted_64 = ["value", "id"]
const _hoisted_65 = ["for"]
const _hoisted_66 = { class: "row mt-3" }
const _hoisted_67 = { class: "col-lg-12 mb-2" }
const _hoisted_68 = { class: "card" }
const _hoisted_69 = { class: "card-header" }
const _hoisted_70 = {
  class: "nav nav-pills card-header-pills",
  id: "pills-tab",
  role: "tablist"
}
const _hoisted_71 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_72 = {
  type: "button",
  class: "nav-link active",
  id: "pills-education-tab",
  "data-bs-toggle": "pill",
  "data-bs-target": "#pills-education"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-graduation-cap mr-1" }, null, -1 /* HOISTED */))
const _hoisted_74 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_75 = {
  type: "button",
  class: "nav-link",
  id: "pills-work_experience-tab",
  "data-bs-toggle": "pill",
  "data-bs-target": "#pills-work_experience"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-briefcase mr-1" }, null, -1 /* HOISTED */))
const _hoisted_77 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_78 = {
  type: "button",
  class: "nav-link",
  id: "pills-certification-tab",
  "data-bs-toggle": "pill",
  "data-bs-target": "#pills-certification"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-certificate mr-1" }, null, -1 /* HOISTED */))
const _hoisted_80 = { class: "card-body" }
const _hoisted_81 = {
  class: "tab-content",
  id: "pills-tabContent"
}
const _hoisted_82 = {
  class: "tab-pane fade show active",
  id: "pills-education",
  role: "tabpanel",
  "aria-labelledby": "pills-home-tab",
  tabindex: "0"
}
const _hoisted_83 = {
  class: "tab-pane fade",
  id: "pills-work_experience",
  role: "tabpanel",
  "aria-labelledby": "pills-work_experience-tab",
  tabindex: "0"
}
const _hoisted_84 = {
  class: "tab-pane fade",
  id: "pills-certification",
  role: "tabpanel",
  "aria-labelledby": "pills-certification-tab",
  tabindex: "0"
}
const _hoisted_85 = { class: "tpd-setting-cartificate" }
const _hoisted_86 = { class: "tpd-setting-cartificate-btn text-right" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = {
  key: 0,
  class: "spinner-border spinner-border-sm mr-5",
  "aria-hidden": "true"
}
const _hoisted_89 = { class: "tpd-setting-password-content" }
const _hoisted_90 = { class: "col-lg-8" }
const _hoisted_91 = { class: "tpd-input" }
const _hoisted_92 = { for: "my-current-password" }
const _hoisted_93 = {
  key: 0,
  class: "invalid-feedback d-block mt-1"
}
const _hoisted_94 = { class: "col-lg-8" }
const _hoisted_95 = { class: "tpd-input" }
const _hoisted_96 = { for: "my-new-password" }
const _hoisted_97 = {
  key: 0,
  class: "invalid-feedback d-block mt-1"
}
const _hoisted_98 = { class: "col-lg-8" }
const _hoisted_99 = { class: "tpd-input" }
const _hoisted_100 = { for: "my-re-new-password" }
const _hoisted_101 = {
  key: 0,
  class: "invalid-feedback d-block mt-1"
}
const _hoisted_102 = { class: "col-lg-8" }
const _hoisted_103 = { class: "tpd-setting-btn" }
const _hoisted_104 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DetailsTable = _resolveComponent("DetailsTable")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString($setup.lms_website.__('Settings')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = $event => ((!$data.form_lading)?$data.active_tab='profile':undefined)),
              class: _normalizeClass({'active':($data.active_tab==='profile'),'pointer-event':(!$data.form_lading)})
            }, _toDisplayString($setup.lms_website.__('Profile')), 3 /* TEXT, CLASS */)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = $event => ((!$data.form_lading)?$data.active_tab='details':undefined)),
              class: _normalizeClass({'active':($data.active_tab==='details'),'pointer-event':(!$data.form_lading)})
            }, _toDisplayString($setup.lms_website.__('Details')), 3 /* TEXT, CLASS */)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = $event => ((!$data.form_lading)?$data.active_tab='password':undefined)),
              class: _normalizeClass({'active':($data.active_tab==='password'),'pointer-event':(!$data.form_lading)})
            }, _toDisplayString($setup.lms_website.__('Password')), 3 /* TEXT, CLASS */)
          ])
        ])
      ])
    ]),
    ($data.active_tab==='profile' || $data.active_tab==='details')
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          method: "post",
          onSubmit: _cache[16] || (_cache[16] = $event => ($options.update_profile($event)))
        }, [
          ($data.active_tab==='profile')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["tpd-setting-box profile", {'form-loading':$data.form_lading}])
              }, [
                _createElementVNode("div", {
                  class: "tp-dashboard-banner-bg profile mb-100",
                  "data-background": ($options.auth.user?.cover_image)?$options.auth.user?.cover_image:'/assets/lms_website/website-assets/img/dashboard/bg/dashboard-bg-1.jpg'
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: ($options.auth.user?.user_image)?$options.auth.user?.user_image:'/assets/lms_website/images/user.png',
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_9),
                        _createElementVNode("span", {
                          class: "pointer-event",
                          onClick: _cache[3] || (_cache[3] = $event => ($options.upload_photo('user_image'))),
                          tooltip: $setup.lms_website.__('Edit Cover Photo')
                        }, _hoisted_12, 8 /* PROPS */, _hoisted_10)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("a", {
                        class: "tp-btn-add-course profile pointer-event",
                        onClick: _cache[4] || (_cache[4] = $event => ($options.upload_photo('cover_image')))
                      }, [
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Edit Cover Photo')), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ], 8 /* PROPS */, _hoisted_5),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", _hoisted_19, _toDisplayString($setup.lms_website.__('First Name')), 1 /* TEXT */),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "first-name",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.user_data.first_name) = $event)),
                          name: "first_name",
                          required: "",
                          disabled: "",
                          readonly: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $data.user_data.first_name]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString($setup.lms_website.__('Last Name')), 1 /* TEXT */),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "last-name",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.user_data.last_name) = $event)),
                          name: "last_name",
                          disabled: "",
                          readonly: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $data.user_data.last_name]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, _toDisplayString($setup.lms_website.__('Username')), 1 /* TEXT */),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "username",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.user_data.username) = $event)),
                          disabled: "",
                          readonly: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $data.user_data.username]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString($setup.lms_website.__('Email')), 1 /* TEXT */),
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          id: "email",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($data.user_data.email) = $event)),
                          name: "email",
                          disabled: "",
                          readonly: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $data.user_data.email]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("label", _hoisted_33, _toDisplayString($setup.lms_website.__('Phone Number')), 1 /* TEXT */),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "phone",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.user_data.phone) = $event)),
                              name: "phone",
                              disabled: "",
                              readonly: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.user_data.phone]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("label", _hoisted_36, _toDisplayString($setup.lms_website.__('Language')), 1 /* TEXT */),
                            _withDirectives(_createElementVNode("select", {
                              id: "language",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.user_data.language) = $event)),
                              name: "language",
                              disabled: "",
                              readonly: ""
                            }, _hoisted_39, 512 /* NEED_PATCH */), [
                              [_vModelSelect, $data.user_data.language]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, _toDisplayString($setup.lms_website.__('Gender')), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "gender",
                            id: "gender-male",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($data.user_data.gender) = $event)),
                            value: "Male",
                            disabled: "",
                            readonly: ""
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelRadio, $data.user_data.gender]
                          ]),
                          _createElementVNode("label", _hoisted_44, _toDisplayString($setup.lms_website.__('Male')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "gender",
                            id: "gender-female",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($data.user_data.gender) = $event)),
                            value: "Female",
                            disabled: "",
                            readonly: ""
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelRadio, $data.user_data.gender]
                          ]),
                          _createElementVNode("label", _hoisted_46, _toDisplayString($setup.lms_website.__('Female')), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("label", _hoisted_49, _toDisplayString($setup.lms_website.__('About Me')), 1 /* TEXT */),
                        _withDirectives(_createElementVNode("textarea", {
                          id: "bio",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($data.user_data.bio) = $event)),
                          name: "bio",
                          disabled: "",
                          readonly: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $data.user_data.bio]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("button", {
                      type: "submit",
                      disabled: $data.form_lading
                    }, [
                      ($data.form_lading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_53))
                        : _createCommentVNode("v-if", true),
                      _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Update Profile')), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_52)
                  ])
                ])
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          ($data.active_tab==='details')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["tpd-setting-box profile", {'form-loading':$data.form_lading}])
              }, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString($setup.lms_website.__('LinkedIn URL')), 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        id: "linkedin",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.user_data.linkedin) = $event)),
                        name: "linkedin",
                        placeholder: ""
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $data.user_data.linkedin]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("label", _hoisted_59, _toDisplayString($setup.lms_website.__('Skills')), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("button", _hoisted_61, _toDisplayString($data.skills.selected.length ? $data.skills.selected.join(', ') : $setup.lms_website.__('Select Skills')), 1 /* TEXT */),
                        _createElementVNode("ul", _hoisted_62, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.skills.list, (skill) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: skill,
                              class: "dropdown-item"
                            }, [
                              _createElementVNode("div", _hoisted_63, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  value: skill,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($data.skills.selected) = $event)),
                                  id: `option-${skill}`
                                }, null, 8 /* PROPS */, _hoisted_64), [
                                  [_vModelCheckbox, $data.skills.selected]
                                ]),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: `option-${skill}`
                                }, _toDisplayString(skill), 9 /* TEXT, PROPS */, _hoisted_65)
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("ul", _hoisted_70, [
                            _createElementVNode("li", _hoisted_71, [
                              _createElementVNode("button", _hoisted_72, [
                                _hoisted_73,
                                _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Education')), 1 /* TEXT */)
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_74, [
                              _createElementVNode("button", _hoisted_75, [
                                _hoisted_76,
                                _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Work Experience')), 1 /* TEXT */)
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_77, [
                              _createElementVNode("button", _hoisted_78, [
                                _hoisted_79,
                                _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Certification')), 1 /* TEXT */)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, [
                              _createVNode(_component_DetailsTable, {
                                "table-name": "education",
                                data: $options.auth?.education,
                                fields: $data.dialog_fields.education,
                                title: $setup.lms_website.__('Education')
                              }, null, 8 /* PROPS */, ["data", "fields", "title"])
                            ]),
                            _createElementVNode("div", _hoisted_83, [
                              _createVNode(_component_DetailsTable, {
                                "table-name": "work_experience",
                                data: $options.auth?.work_experience,
                                fields: $data.dialog_fields.work_experience,
                                title: $setup.lms_website.__('Work Experience')
                              }, null, 8 /* PROPS */, ["data", "fields", "title"])
                            ]),
                            _createElementVNode("div", _hoisted_84, [
                              _createVNode(_component_DetailsTable, {
                                "table-name": "certification",
                                data: $options.auth?.certification,
                                fields: $data.dialog_fields.certifications,
                                title: $setup.lms_website.__('Certification')
                              }, null, 8 /* PROPS */, ["data", "fields", "title"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("button", {
                      type: "submit",
                      disabled: $data.form_lading
                    }, [
                      ($data.form_lading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_88))
                        : _createCommentVNode("v-if", true),
                      _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Update Details')), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_87)
                  ])
                ])
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ], 32 /* NEED_HYDRATION */))
      : _createCommentVNode("v-if", true),
    ($data.active_tab==='password')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["tpd-setting-box", {'form-loading':$data.paasword.is_loading}])
        }, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("label", _hoisted_92, _toDisplayString($setup.lms_website.__('Current Password')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: _normalizeClass({'is-invalid':$data.paasword.errors.old_password}),
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (($data.paasword.old_password) = $event)),
                    id: "my-current-password",
                    autocomplete: "off",
                    style: {"direction":"ltr","text-align":"left"}
                  }, null, 2 /* CLASS */), [
                    [_vModelText, $data.paasword.old_password]
                  ]),
                  ($data.paasword.errors.old_password)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString($data.paasword.errors.old_password), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("label", _hoisted_96, _toDisplayString($setup.lms_website.__('New Password')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: _normalizeClass({'is-invalid':$data.paasword.errors.new_password}),
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($data.paasword.new_password) = $event)),
                    id: "my-new-password",
                    autocomplete: "off",
                    style: {"direction":"ltr","text-align":"left"}
                  }, null, 2 /* CLASS */), [
                    [_vModelText, $data.paasword.new_password]
                  ]),
                  ($data.paasword.errors.new_password)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString($data.paasword.errors.new_password), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("label", _hoisted_100, _toDisplayString($setup.lms_website.__('Re-type New Password')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: _normalizeClass({'is-invalid':$data.paasword.errors.confirm_password}),
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($data.paasword.confirm_password) = $event)),
                    id: "my-re-new-password",
                    autocomplete: "off",
                    style: {"direction":"ltr","text-align":"left"}
                  }, null, 2 /* CLASS */), [
                    [_vModelText, $data.paasword.confirm_password]
                  ]),
                  ($data.paasword.errors.confirm_password)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString($data.paasword.errors.confirm_password), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("button", {
                    onClick: _cache[20] || (_cache[20] = (...args) => ($options.change_password && $options.change_password(...args))),
                    disabled: $data.paasword.is_loading
                  }, _toDisplayString($setup.lms_website.__('Set New Password')), 9 /* TEXT, PROPS */, _hoisted_104)
                ])
              ])
            ])
          ])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}